import { createContext, useState, ReactNode, useContext } from 'react';
import { AtualizaEmailProps } from '../types/email-atualiza-interface';
import { AtualizaTelefoneProps } from '../types/telefone-atualiza-interface';
import { DadosPausasType } from '../components/Discador/types';
import { DadosPausasType as DadosPausasTypeExpert } from '../components/DiscadorExpert/types';
import { Usuario } from '../types/supervisao/usuario-interface';

interface ModalContextProviderProps {
  children: ReactNode;
}

interface ModalInfoProps {
  isOpen: boolean;
  title: string;
  type: string;
}

interface SucessoModalProps {
  isOpen: boolean;
  title: string;
}

interface ModalContextProps {
  modalInfo: ModalInfoProps;
  infoTel: AtualizaTelefoneProps;
  infoEmail: AtualizaEmailProps;
  setModal: (title: string, type: string, isSuccess?: boolean, isError?: boolean, isPausa?: boolean) => void;
  onClose: (isSuccess?: boolean, isError?: boolean, isAviso?: boolean, isDiscador?: boolean) => void;
  getInfoTel(telefone: AtualizaTelefoneProps): void;
  getInfoEmail(email: AtualizaEmailProps): void;
  getHorarioInfo(telefone: AtualizaTelefoneProps): void;
  getInfoPausa(pausa: DadosPausasType): void;
  setInfoUsuario: React.Dispatch<React.SetStateAction<Usuario>>
  infoUsuario: Usuario
  telefone: AtualizaTelefoneProps;
  openSucessoModal: SucessoModalProps;
  openErrorModal: SucessoModalProps;
  openTabFinModal: SucessoModalProps;
  openAvisoModal: SucessoModalProps;
  openDiscadorModal: SucessoModalProps;
  infoPausa: DadosPausasType;
  openTipoDiscagemModal: SucessoModalProps
}

const ModalContext = createContext<ModalContextProps>({} as ModalContextProps);

export const ModalProvider = ({ children }: ModalContextProviderProps) => {
  const [modalInfo, setModalInfo] = useState<ModalInfoProps>({
    isOpen: false,
    title: '',
    type: '',
  });
  const [infoTel, setInfoTel] = useState<AtualizaTelefoneProps>({} as AtualizaTelefoneProps);
  const [infoEmail, setInfoEmail] = useState<AtualizaEmailProps>({} as AtualizaEmailProps);
  const [infoUsuario, setInfoUsuario] = useState<Usuario>({} as Usuario);
  const [infoPausa, setInfoPausa] = useState<DadosPausasType>({} as DadosPausasType);
  const [telefone, setTelefone] = useState({} as AtualizaTelefoneProps);
  const [openSucessoModal, setSucessoModal] = useState<SucessoModalProps>({} as SucessoModalProps);
  const [openErrorModal, setErrorModal] = useState<SucessoModalProps>({} as SucessoModalProps);
  const [openTabFinModal, setTabFinModal] = useState<SucessoModalProps>({} as SucessoModalProps);
  const [openAvisoModal, setAvisoModal] = useState<SucessoModalProps>({} as SucessoModalProps);
  const [openDiscadorModal, setDiscadorModal] = useState<SucessoModalProps>({} as SucessoModalProps);
  const [openTipoDiscagemModal, setTipoDiscagemModal] = useState<SucessoModalProps>({} as SucessoModalProps);

  function setModal(title: string, type: string, isSuccess?: boolean, isError?: boolean, isPausa?: boolean) {
    if (isSuccess) {
      setSucessoModal({ isOpen: true, title });
    } else if (type === 'Aviso') {
      setAvisoModal({ isOpen: true, title });
      return;
    } else if (title === 'Discador') {
      setDiscadorModal({ isOpen: true, title });
      return;
    } else if (isError) {
      setErrorModal({ isOpen: true, title });
    } else if (type === 'Finalizar Tabulação') {
      setTabFinModal({ isOpen: true, title });

    } else if (type === 'Tipo Discagem') {
      setTipoDiscagemModal({ isOpen: true, title });
    } else {
      // console.log({ isOpen: true, title, type });
      setModalInfo({ isOpen: true, title, type });
    }
  }

  function onClose(isSuccess?: boolean, isError?: boolean, isAviso?: boolean, isDiscador?: boolean) {
    if (isSuccess) {
      setSucessoModal({ isOpen: false, title: '' });
    } else if (isError) {
      setErrorModal({ isOpen: false, title: '' });
    } else if (isAviso) {
      setAvisoModal({ isOpen: false, title: '' });
    } else if (isDiscador) {
      setDiscadorModal({ isOpen: false, title: '' });
    } else {
      setModalInfo({ isOpen: false, title: '', type: '' });
      setTabFinModal({ isOpen: false, title: '' });
      setInfoEmail({} as AtualizaEmailProps);
      setInfoTel({} as AtualizaTelefoneProps);
      setTipoDiscagemModal({ isOpen: false, title: '' })
    }
  }

  function getHorarioInfo(telefone: AtualizaTelefoneProps) {
    setTelefone(telefone);
  }

  function getInfoTel(telefone: AtualizaTelefoneProps) {
    setInfoTel(telefone);
  }
  function getInfoEmail(email: AtualizaEmailProps) {
    setInfoEmail(email);
  }

  function getInfoPausa(pausa: DadosPausasType) {
    setInfoPausa(pausa);
  }

  return (
    <ModalContext.Provider
      value={{
        modalInfo,
        setModal,
        onClose,
        getInfoTel,
        infoTel,
        infoEmail,
        getInfoEmail,
        getHorarioInfo,
        telefone,
        openSucessoModal,
        openErrorModal,
        openTabFinModal,
        openAvisoModal,
        openDiscadorModal,
        getInfoPausa,
        infoPausa,
        infoUsuario,
        setInfoUsuario,
        openTipoDiscagemModal
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
